/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import {
  currencyFormatter,
  toAbsoluteUrl
} from "../../../../_metronic/_helpers";
import { CircularProgress } from "@material-ui/core";
import Table from "react-bootstrap/Table";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";

export function TopTableList({
  className,
  widgetHeight = "450px",
  title = "",
  data = [],
  loading = false,
  th1 = "",
  th2 = ""
}) {
  return (
    <>
      <Card className={`card card-custom overflow-auto ${className}`} style={{ height: widgetHeight }}>
        <CardBody>
          <div className='align-self-center' >
            <p className="text-hover-primary text-center font-weight-bold font-size-h4">
              {title}
            </p>
            <div className="overflow-auto">
              <Table className="overflow-auto" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th className="text-left">No</th>
                    <th className="text-left">{th1}</th>
                    <th className="text-right">{th2}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    return (
                      <tr>
                        <td className="text-left">{index + 1}</td>
                        <td className="text-left">{item.name}</td>
                        <td className="text-right">
                          {currencyFormatter(
                            item.total_amount,
                            { decimalSeparator: "" },
                            false
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
